import PortOpeningRuleOnPrem from '../../entities/PortOpeningRuleOnPrem';

export default class SubmitPortOpeningRequestRuleOnPrem {

	action!: string;

	operation!: string;

	sslBypass!: boolean;

	sourceIPs!: string;

	destinationIPs!: string;

    destinationURLs!: string;

	destinationPorts!: string;

	description!: string;

	protocol!: string;

	ruleName: string;

	constructor(rule: PortOpeningRuleOnPrem) {
		Object.assign(this, rule);
		this.action = rule.action?.name;
		this.operation = rule.operation?.name;
		this.ruleName = rule.name;
	}
}